import Overlay from "@8x8/oxygen-overlay";
import { Spinner } from "@8x8/oxygen-loaders";

import React from "react";
import styled from "styled-components";
import { COLORS } from "@/react/theme/constants";
import { MAXIMUM_Z_INDEX } from "@/react/ui/constants";

const Centered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const LighterOverlay = styled(Overlay)`
  background-color: ${COLORS.tertiary}B3; // B3 = 70% opacity
  z-index: ${(props) => props.zIndex || MAXIMUM_Z_INDEX};
`;

export const OverlaySpinner = (props) => {
  return (
    <LighterOverlay zIndex={props.zIndex}>
      <Centered>
        <Spinner {...props} />
      </Centered>
    </LighterOverlay>
  );
};
